import React, {PureComponent as Component} from 'react';
import ContentLoader from 'react-content-loader'

import InputText from "../../../ui/template/Input/InputText";
import FormManager from "../../../ui/template/Form/FormManager";
import Submit from "../../../ui/template/Form/Submit";
import Alerts from "../../../ui/template/Alert/Alerts";
import {MCbrowser} from "../../Context/browserContext";
import {Facebook, Instagram, Twitter} from "react-feather";
import getSocialApi from "./Api/getSocial";
import postSocialApi from "./Api/postSocial";
import PropTypes from "prop-types";


class  EditSocial extends Component{

    constructor(props) {
        super(props);

        this.HinstagramChange = this.instagramChange.bind(this);
        this.HfacebookChange = this.facebookChange.bind(this);
        this.HtwitterChange = this.twitterChange.bind(this);
        this.handlePostUp = this.postUp.bind(this);
        this.state = {isload: false, isClose: false};
        this.values = {  instagram: '',facebook: '',twitter:"" };
        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.getLoadForm = this.getLoad.bind(this);
        this.components= {
            instagram: React.createRef(),
            facebook: React.createRef(),
            twitter: React.createRef(),
        };
        this.props=props;
    }

    instagramChange(e) {
        this.values.instagram= e.target.value;
        return true;
    }

    facebookChange(e) {
        this.values.facebook= e.target.value;
        return true;
    }

    twitterChange(e) {
        this.values.twitter= e.target.value;
        return true;
    }


    async postUp() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await postSocialApi(this.values.instagram,this.values.facebook,this.values.twitter, pageAlerts,this.formAlerts);
        if(l===true){

        }
    }

    async getLoad() {
        let data=await getSocialApi();
        if(data===false){
            this.setState({isloadData:true});
        }else{
            let components=this.components;
            this.setState({isload: true, isClose: false});

            if(data.instagram!=null) this.values.instagram = data.instagram;
            if(data.facebook!=null) this.values.facebook = data.facebook;
            if(data.twitter!=null) this.values.twitter = data.twitter;

            Object.keys(this.components).forEach(element => {
                if (data.hasOwnProperty(element)) {
                    if(data[element]!=null) components[element].current.setValue(data[element]);
                }
            });
        }
    }

    componentDidMount(){
        this.getLoadForm();
    }

    render() {
        if (this.state.isload) {
            let c="";
            if(this.props.isSticky) c="side-sticky";
            return ( <FormManager className={c} ref={this.form1} submit={this.handlePostUp}>
                            <div className="border rounded bg-white mb-3">
                                <div className="box-title border-bottom p-3">
                                    <h6 className="m-0">
                                        شبکات اجتماعی
                                    </h6>
                                    <p className="mb-0 mt-0 small">
                                        افزودن لینک شبکات دیگر
                                    </p>
                                </div>
                                <div className="box-body">
                                    <div className="p-3 border-bottom">
                                        <div className="position-relative icon-form-control mb-2">
                                            <Instagram class="position-absolute text-warning" size={16} />
                                            <InputText placeholder="لینک اینستگرام"
                                                className="form-control" ref={this.components.instagram}  onChange={this.HinstagramChange}  />
                                        </div>
                                        <div className="position-relative icon-form-control mb-2">
                                            <Facebook class="position-absolute text-primary" size={16} />
                                            <InputText placeholder="لینک فیسبوک"
                                                       className="form-control" ref={this.components.facebook}  onChange={this.HfacebookChange}  />
                                        </div>
                                        <div className="position-relative icon-form-control mb-2">
                                            <Twitter class="position-absolute text-info" size={16} />
                                            <InputText placeholder="لینک تویتر"
                                                       className="form-control" ref={this.components.twitter}  onChange={this.HtwitterChange}  />
                                        </div>
                                        <Alerts layout="relative" ref={this.formAlerts} />
                                    </div>
                                    <div className="overflow-hidden text-center p-3">
                                        <Submit className="font-weight-bold btn btn-light rounded p-3 d-block  w-100"  >
                                            ثیت تغییرات شبکات
                                        </Submit>
                                    </div>
                                </div>
                            </div>
                    </FormManager>);
        }else{
            return (   <div className="border rounded bg-white mb-3">
                            <div className="box-title border-bottom p-3">
                                <h6 className="m-0">
                                    شبکات اجتماعی
                                </h6>
                            </div>
                            <div className="box-body">
                                <ContentLoader width="100%" height="150px">
                                    <rect x="10%" y="20" rx="5" ry="5" width="75%" height="30" />
                                    <rect x="10%" y="60" rx="5" ry="5" width="75%" height="30" />
                                    <rect x="10%" y="100" rx="5" ry="5" width="75%" height="30" />
                                </ContentLoader>
                            </div>
                        </div> );
        }
    }
}

EditSocial.contextType = MCbrowser;

EditSocial.propTypes = {
    isSticky: PropTypes.bool,
};

EditSocial.defaultProps = {
    isSticky:false
};

export default EditSocial;
